import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
`;

export const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid ${props => props.theme.colors.neutral[200]};
  border-top-color: ${props => props.theme.colors.new_primary[500]};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

export const Container = styled.div`
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  min-height: 400px;
`;

export const Content = styled.div`
  margin-top: auto;
  margin-bottom: auto;
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: ${props => props.theme.colors.neutral[700]};
  margin-bottom: 8px;
  line-height: 1.3;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  color: ${props => props.theme.colors.neutral[500]};
  margin-bottom: 32px;
`;

export const AuthButton = styled.button`
  display: block;
  width: 100%;
  height: 50px;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 600;
  color: ${props => props.theme.colors.neutral.white};
  cursor: pointer;
  background: ${props => props.theme.colors.new_primary[500]};
  transition: background 0.2s;

  &:hover {
    background: ${props => props.theme.colors.new_primary[600]};
  }
`;
